// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"\"Moderat\",-apple-system,blinkmacsystemfont,roboto,\"Droid Sans\",sans-serif","container":"Invitation_container__3B4DS"};